module.exports = __webpack_public_path__ + "assets/img/12.fbe0dbb0.jpg";